import {
  GET_YOUTUBE_VIDEOS,
  GET_YOUTUBE_VIDEOS_SUCCESS,
  GET_YOUTUBE_VIDEOS_FAIL,
  GET_YOUTUBE_VIDEO_DETAILS,
  GET_YOUTUBE_VIDEO_DETAILS_SUCCESS,
  GET_YOUTUBE_VIDEO_DETAILS_FAIL,
  CREATE_YOUTUBE_VIDEO,
  CREATE_YOUTUBE_VIDEO_SUCCESS,
  CREATE_YOUTUBE_VIDEO_FAIL,
  UPDATE_YOUTUBE_VIDEO,
  UPDATE_YOUTUBE_VIDEO_SUCCESS,
  UPDATE_YOUTUBE_VIDEO_FAIL,
  DELETE_YOUTUBE_VIDEO_SUCCESS,
  DELETE_YOUTUBE_VIDEO_FAIL,
  DELETE_YOUTUBE_VIDEO,

} from "./actionTypes"

// YoutubeVideo - This line cannot be edited or removed
export const getYoutubeVideos = (
  page,
  limit,
  searchText,
  youtubeVideoId,

) => ({
  type: GET_YOUTUBE_VIDEOS,
  payload: { page, limit, searchText, youtubeVideoId,  },
})

export const getYoutubeVideosSuccess = youtubeVideos => ({
  type: GET_YOUTUBE_VIDEOS_SUCCESS,
  payload: youtubeVideos,
})

export const getYoutubeVideosFail = error => ({
  type: GET_YOUTUBE_VIDEOS_FAIL,
  payload: error,
})

export const getYoutubeVideoDetails = youtubeVideoId => ({
  type: GET_YOUTUBE_VIDEO_DETAILS,
  payload: youtubeVideoId,
})

export const getYoutubeVideoDetailsSuccess = youtubeVideoDetails => ({
  type: GET_YOUTUBE_VIDEO_DETAILS_SUCCESS,
  payload: youtubeVideoDetails,
})

export const getYoutubeVideoDetailsFail = error => ({
  type: GET_YOUTUBE_VIDEO_DETAILS_FAIL,
  payload: error,
})

export const createYoutubeVideo = (youtubeVideo, onCloseClick) => ({
  type: CREATE_YOUTUBE_VIDEO,
  payload: { youtubeVideo, onCloseClick },
})

export const createYoutubeVideoSuccess = youtubeVideo => ({
  type: CREATE_YOUTUBE_VIDEO_SUCCESS,
  payload: youtubeVideo,
})

export const createYoutubeVideoFail = error => ({
  type: CREATE_YOUTUBE_VIDEO_FAIL,
  payload: error,
})

export const getYoutubeVideoDetail = youtubeVideoId => ({
  type: GET_YOUTUBE_VIDEO_DETAILS,
  payload: youtubeVideoId,
})

export const updateYoutubeVideo = (youtubeVideo, youtubeVideoId, onCloseClick) => ({
  type: UPDATE_YOUTUBE_VIDEO,
  payload: { youtubeVideo, youtubeVideoId, onCloseClick },
})

export const updateYoutubeVideoSuccess = youtubeVideo => ({
  type: UPDATE_YOUTUBE_VIDEO_SUCCESS,
  payload: youtubeVideo,
})

export const updateYoutubeVideoFail = error => ({
  type: UPDATE_YOUTUBE_VIDEO_FAIL,
  payload: error,
})

export const deleteYoutubeVideo = youtubeVideoId => ({
  type: DELETE_YOUTUBE_VIDEO,
  payload: { youtubeVideoId },
})

export const deleteYoutubeVideoSuccess = youtubeVideo => ({
  type: DELETE_YOUTUBE_VIDEO_SUCCESS,
  payload: youtubeVideo,
})

export const deleteYoutubeVideoFail = error => ({
  type: DELETE_YOUTUBE_VIDEO_FAIL,
  payload: error,
})
